import React from 'react';
import { DateFormat, getDateString } from '../../../../../../ui-toolkit/utilities/getDateString';
import { ICheckDisbursementFormData } from 'types/order/escrow/checks/ICheckDisbursementFormData';

interface CheckDetailsDisplayProps {
  data: ICheckDisbursementFormData;
}

export const CheckDetailsDisplay: React.FC<CheckDetailsDisplayProps> = ({ data }) => {
  return (
    <>
      {data.checkNumber && (
        <div>
          <span className={'font-semibold'}>Check #:</span> {data.checkNumber}
        </div>
      )}
      {data.sentAtDate && (
        <div>
          <span className={'font-semibold'}>Initiated Date:</span> {getDateString(DateFormat.short, data.sentAtDate)}
        </div>
      )}
      {(data.completedAtDate || data.completedAt) && (
        <div>
          <span className={'font-semibold'}>Disbursed Date:</span>{' '}
          {data.completedAt
            ? getDateString(DateFormat.shortDateTime, data.completedAt, true)
            : getDateString(DateFormat.short, data.completedAtDate)}
        </div>
      )}
      {data.voidedAt && (
        <div>
          <span className={'font-semibold'}>Voided Date:</span>{' '}
          {getDateString(DateFormat.shortDateTime, data.voidedAt, true)}
        </div>
      )}
      {data.voidReason && (
        <div>
          <span className={'font-semibold'}>Voided Reason:</span> {data.voidReason}
          {data.voidReasonDescription && ` - ${data.voidReasonDescription}`}
        </div>
      )}
    </>
  );
};
